// extracted by mini-css-extract-plugin
export default {"icon":"social-mentions-pieces-UrlDomain__icon--AwKgC"};